import React from 'react';



const SuggestedPrompts = ({ onPromptSelect, isVisible = true, prompts = null }) => {
  // Default prompts if none provided
  const defaultPrompts = [
    "I want to plan a family camping trip for this summer",
    "What are the best state parks for hiking and photography?", 
    "Help me find budget-friendly state parks near me",
    "I\'m looking for parks with swimming and water activities"
  ];

  const promptsToShow = prompts || defaultPrompts;

  if (!isVisible) return null;

  return (
    <div className={`transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
      <div className="px-6 py-4 bg-white border-t border-gray-100">
        <div className="max-w-4xl mx-auto">
          <h3 className="text-sm font-medium text-gray-700 mb-3">Suggested questions to get started:</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {promptsToShow?.map((prompt, index) => (
              <button
                key={index}
                onClick={() => onPromptSelect?.(prompt)}
                className="p-3 text-left bg-blue-50 hover:bg-blue-100 rounded-lg border border-blue-200 transition-colors duration-200 group"
              >
                <span className="text-sm text-blue-800 group-hover:text-blue-900">
                  {prompt}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuggestedPrompts;